export const APP_VISIBILITY_EVENT = "cp_ecommerce_apps";
